var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.994 6.503a2.515 2.515 0 0 0 3.792.272l1.508-1.51A2.518 2.518 0 0 0 8.508 1a2.51 2.51 0 0 0-1.769.706l-.865.861m1.132 2.93a2.515 2.515 0 0 0-3.792-.272l-1.508 1.51A2.518 2.518 0 0 0 3.492 11a2.51 2.51 0 0 0 1.769-.707l.86-.86"
  })));
};
export default SvgLink;